import { render } from "./shuffle-prompts.vue?vue&type=template&id=7eee861a&lang=pug"
import script from "./shuffle-prompts.vue?vue&type=script&lang=js"
export * from "./shuffle-prompts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__